import { BaseMethod } from "./_Base";
import { CoreWalker } from "../../../core/Walker";
import { CopySopNode } from "../../nodes/sop/Copy";
export class CopyExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
  }
  static requiredArguments() {
    return [
      ["string", "path to copy"],
      ["integer", "default value"]
    ];
  }
  static optionalArguments() {
    return [["string", "attribute name (optional)"]];
  }
  findDependency(indexOrPath) {
    const node = this.findReferencedGraphNode(indexOrPath);
    if (node && node.type() == "copy") {
      const stampNode = node.stampNode();
      return this.createDependency(stampNode, indexOrPath);
    }
    return null;
  }
  processArguments(args) {
    return new Promise((resolve, reject) => {
      if (args.length >= 1) {
        const path = args[0];
        const defaultValue = args[1] || 0;
        const attributeName = args[2];
        const currentNode = this.node();
        const node = currentNode ? CoreWalker.findNode(currentNode, path) : null;
        let value;
        if (node && node.type() == CopySopNode.type()) {
          value = node.stampValue(attributeName);
        }
        if (value == null) {
          value = defaultValue;
        }
        resolve(value);
      } else {
        resolve(0);
      }
    });
  }
}
